/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 05/03/2025
 */

import { Menu } from '@mui/icons-material'
import { Box, IconButton, ListItemText, MenuItem, MenuList, SwipeableDrawer } from '@mui/material'
import React, { useState } from 'react'
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';

import styles from "./navBar.module.css";
import { Link } from 'react-router-dom';
import logo from '../../assets/images/logo.jpg'
import { pink } from '@mui/material/colors';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

const DrawerMenu = () => {

    const [open, setOpen] = React.useState(true);

    const handleClick = () => {
        setOpen(!open);
    };

    const [position, setPosition] = useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
    });

    const toggleDrawer = (anchor, open) => (event) => {
        if (
            event &&
            event.type === 'keydown' &&
            (event.key === 'Tab' || event.key === 'Shift')
        ) {
            return;
        }
        setPosition({ ...position, [anchor]: open });
    };

    const links = [
        { id: 1, name: 'Home', link: '/' },
        { id: 2, name: 'About us', link: '/aboutUs' },
        { id: 3, name: 'Services', link: '/services' },
        { id: 4, name: 'Products', link: 'products' },
        { id: 5, name: 'Contact', link: 'contact' },
    ]

    const list = (anchor) => (
        <Box
            className={styles.menuContainer}
            role="presentation"
            onClick={toggleDrawer(anchor, false)}
            onKeyDown={toggleDrawer(anchor, false)}
        >
            <img className={styles.image} src={logo} />
            <MenuList className={styles.listContainer}>
                {/* {links.map(item => (
                    <Link key={item.link} className={styles.link} to={item.link}>
                        <MenuItem className={styles.listItem}>
                            <ListItemText>{item.name}</ListItemText>
                        </MenuItem>
                    </Link>
                ))} */}

                <Link className={styles.link} to='/' >
                    <MenuItem className={styles.listItem}>
                        <ListItemText>Home</ListItemText>
                    </MenuItem>
                </Link>
                <Link className={styles.link} to='/aboutUs' >
                    <MenuItem className={styles.listItem}>
                        <ListItemText>About us</ListItemText>
                    </MenuItem>
                </Link>
                <Link className={styles.link} to='/services' >
                    <MenuItem className={styles.listItem}>
                        <ListItemText>Services</ListItemText>
                    </MenuItem>
                </Link>

                {/* <Link className={styles.link} > */}
                    <MenuItem className={styles.listItem} onClick={(e) => {
                        e.preventDefault(); // Prevent triggering the drawer close event
                        handleClick();
                    }}>
                        <ListItemText>Products</ListItemText>
                        {open ? <ExpandLess /> : <ExpandMore />}
                    </MenuItem>

                {/* </Link> */}

                <Collapse in={open} timeout="auto" unmountOnExit>

                    <List component="div" disablePadding>
                        <Link className={styles.link} to='/ecom' >
                            <MenuItem className={styles.subListItem}>
                                <ListItemText primary="E-Commerce web" />
                            </MenuItem>
                        </Link>

                        <Link className={styles.link} to='/hr' >
                            <MenuItem className={styles.subListItem}>
                                <ListItemText primary="HR Management System" />
                            </MenuItem>
                        </Link>

                        <Link className={styles.link} to='/ims' >
                            <MenuItem className={styles.subListItem}>
                                <ListItemText primary="Issue Management System" />
                            </MenuItem>
                        </Link>

                        <Link className={styles.link} to='/crm' >
                            <MenuItem className={styles.subListItem}>
                                <ListItemText primary="CRM System" />
                            </MenuItem>
                        </Link>

                        <Link className={styles.link} to='/payroll' >
                            <MenuItem className={styles.subListItem}>
                                <ListItemText primary="Payroll System" />
                            </MenuItem>
                        </Link>

                        <Link className={styles.link} to='/eservice' >
                            <MenuItem className={styles.subListItem}>
                                <ListItemText primary="E Services" />
                            </MenuItem>
                        </Link>

                        <Link className={styles.link} to='/stock' >
                            <MenuItem className={styles.subListItem}>
                                <ListItemText primary="Stocks and Warehouse Monitoring" />
                            </MenuItem>
                        </Link>

                        <Link className={styles.link} to='/pos' >
                            <MenuItem className={styles.subListItem}>
                                <ListItemText primary="Point Of Sale" />
                            </MenuItem>
                        </Link>

                        <Link className={styles.link} to='/ecomlite' >
                            <MenuItem className={styles.subListItem}>
                                <ListItemText primary="E-Commerce lite web" />
                            </MenuItem>
                        </Link>
                    </List>

                </Collapse>

                <Link className={styles.link} to='/contact' >
                    <MenuItem className={styles.listItem}>
                        <ListItemText>Contact</ListItemText>
                    </MenuItem>
                </Link>



            </MenuList>
        </Box>
    );

    return (
        <div
            className={styles.menu}
        >
            <IconButton
                onClick={toggleDrawer('right', true)} sx={{ color: pink[50] }}>
                <Menu />
            </IconButton>
            <SwipeableDrawer
                anchor={'right'}
                open={position['right']}
                onClose={toggleDrawer('right', false)}
                onOpen={toggleDrawer('right', true)}
            >
                {list('right')}
            </SwipeableDrawer>
        </div>
    )
}

export default DrawerMenu